/*************************************************/
/* VACNCIES                                      */
/*************************************************/

export function vacancies() {
    const filter = document.getElementById("locationFilter");
    const vacancies = document.querySelectorAll(".vacancy__item");


    const init = () => {
        if (filter) {
            filter.addEventListener("change", function () {
                const selected = this.value.toLowerCase();
                
                vacancies.forEach(item => {
                const locations = item.getAttribute("data-location")?.toLowerCase().split(",").map(s => s.trim());
                
                if (selected === "all" || locations.includes(selected)) {
                    item.style.display = "block";
                } else {
                    item.style.display = "none";
                }
            });
        });
    }
    };
    init();
}
